export default __webpack_public_path__ + "static/media/check-decagram-outline.5aa48efe.svg";